/** RBAC header roles are only User / Manager (plus staff). Never send Owner. */
export const toApiUserRole = (role) => {
    const raw = String(role || '').trim();
    if (!raw) return 'User';
    const key = raw.toLowerCase().replace(/[\s_]+/g, '');
    if (key === 'owner' || key === 'user') return 'User';
    if (key === 'manager') return 'Manager';
    return raw;
};

const ROLE_CODE_LABELS = {
    OWNER: 'User',
    USER: 'User',
    MANAGER: 'Manager',
    COLLECTOR: 'Collector',
    ACCOUNTANT: 'Accountant',
    RECEPTIONIST: 'Receptionist',
    KITCHEN_STAFF: 'Kitchen Staff',
    SALESMAN: 'Salesman',
    PHARMACIST: 'Pharmacist',
    DOCTOR: 'Doctor',
    NURSE: 'Nurse',
    COMPOUNDER: 'Compounder',
};

export const formatRoleLabel = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return '';
    return raw
        .split(/[\s_]+/)
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
        .join(' ');
};

/**
 * Resolve display role for navbar "Logged in as {Role}".
 * Prefers platform active context, then userRole / accountName, then path fallback.
 */
export const getLoggedInRoleLabel = ({
    platform,
    userRole,
    userAccounts,
    pathname = '',
} = {}) => {
    const activeRoleCode = String(platform?.activeContext?.roleCode || '').toUpperCase();
    if (activeRoleCode && ROLE_CODE_LABELS[activeRoleCode]) {
        return ROLE_CODE_LABELS[activeRoleCode];
    }

    const normalizedUserRole = String(userRole || '').trim().toUpperCase();
    if (normalizedUserRole && ROLE_CODE_LABELS[normalizedUserRole]) {
        return ROLE_CODE_LABELS[normalizedUserRole];
    }

    const fromUserRole = formatRoleLabel(userRole);
    if (fromUserRole) return fromUserRole;

    const accounts = Array.isArray(userAccounts) ? userAccounts : [];
    const accountName = accounts.find((account) => account?.accountName)?.accountName;
    if (accountName) {
        const accountCode = String(accountName).trim().toUpperCase();
        if (ROLE_CODE_LABELS[accountCode]) return ROLE_CODE_LABELS[accountCode];
        return formatRoleLabel(accountName);
    }

    if (platform?.isOwner) return 'User';

    const path = String(pathname || '');
    if (path.includes('/kitchenstaff') || path.includes('/kitchen')) return 'Kitchen Staff';
    if (path.includes('/pharmacist')) return 'Pharmacist';
    if (path.includes('/compounder')) return 'Compounder';
    if (path.includes('/nurse')) return 'Nurse';
    if (path.includes('/receptionist')) return 'Receptionist';
    if (path.includes('/salesman')) return 'Salesman';
    if (path.includes('/doctor')) return 'Doctor';
    if (path.includes('/resident')) return 'Resident';
    if (path.includes('/manager')) return 'Manager';
    if (path.includes('/collector')) return 'Collector';
    if (path.includes('/accountant')) return 'Accountant';
    if (path.includes('/subscriber')) return 'Subscriber';
    if (path.includes('/vehicle-parking/customer')) return 'Subscriber';
    if (path.includes('/user')) return 'User';

    return 'User';
};

export { ROLE_CODE_LABELS };
